
        import V from 'voUtils/V.js';
        import Vue from 'vue';
        import {voMsg,voMsgPl} from './voUtils/voI18n.js';
        import DateEx from './voUtils/DateEx.js';

        Vue.prototype.VOFFICE = window.VOFFICE;

        var voFormatDate = DateEx.formatDate;

        import AirbnbStyleDatepicker from 'base/vue-airbnb-style-datepicker'
        import 'base/vue-airbnb-style-datepicker/dist/vue-airbnb-style-datepicker.min.css'

        var vueApps = {};

        var methods = {voMsg,voMsgPl,voFormatDate};

        
            import App0 from './app/unit.js';
            vueApps['app/unit.js'] = App0;
        

            import App1 from './app/dummy.js';
            vueApps['app/dummy.js'] = App1;
        

            import App2 from './app/indexMap.js';
            vueApps['app/indexMap.js'] = App2;
        

            import App3 from './app/search.js';
            vueApps['app/search.js'] = App3;
        

            import App4 from './app/navbar.js';
            vueApps['app/navbar.js'] = App4;
        

            import App5 from './app/angebote.js';
            vueApps['app/angebote.js'] = App5;
        

            import App6 from './app/SimilarUnits.js';
            vueApps['app/SimilarUnits.js'] = App6;
        

            import App7 from './app/FacilityUnits.js';
            vueApps['app/FacilityUnits.js'] = App7;
        

            import App8 from './app/facility.js';
            vueApps['app/facility.js'] = App8;
        

            import App9 from './app/LastViewedUnits.js';
            vueApps['app/LastViewedUnits.js'] = App9;
        

            import App10 from './app/mithund.js';
            vueApps['app/mithund.js'] = App10;
        

        
                import Comp11 from './comp/DateRange.vue';
                Vue.component('voffice-daterange',Comp11);
            

                import Comp12 from './comp/DateRangeExt.vue';
                Vue.component('voffice-daterange-ext',Comp12);
            

                import Comp13 from './comp/GuestBox.vue';
                Vue.component('voffice-guestbox',Comp13);
            

                import Comp14 from './comp/Booking.js';
                Vue.component('voffice-booking',Comp14);
            

                import Comp15 from './comp/DocBox.vue';
                Vue.component('voffice-doc-box',Comp15);
            

                import Comp16 from './comp/ErrorMessage.vue';
                Vue.component('voffice-error-message',Comp16);
            

                import Comp17 from './comp/ImgFallback.vue';
                Vue.component('img-fallback',Comp17);
            

                import Comp18 from './comp/FavElement.vue';
                Vue.component('voffice-fav-element',Comp18);
            

                import Comp19 from './comp/Voucher-Unit.vue';
                Vue.component('voffice-voucher-unit',Comp19);
            

                import Comp20 from './comp/MaxTextSize.js';
                Vue.component('voffice-max-text-size',Comp20);
            

                import Comp21 from './comp/PopupBox.vue';
                Vue.component('voffice-popup-box',Comp21);
            

                import Comp22 from './comp/PhotoSwipe.js';
                Vue.component('voffice-photoswipe',Comp22);
            

                import Comp23 from './comp/PopupDialog.vue';
                Vue.component('voffice-popup-dlg',Comp23);
            

                import Comp24 from './pano.js';
                Vue.component('panorama',Comp24);
            

                import Comp25 from './comp/SearchFilterTokens.vue';
                Vue.component('search-filter-tokens',Comp25);
            

                import Comp26 from './imageCarousel.vue';
                Vue.component('img-carousel',Comp26);
            

                import Comp27 from './pricehelp.vue';
                Vue.component('price-help',Comp27);
            

                import Comp28 from './comp/Accordion.vue';
                Vue.component('voffice-accordion',Comp28);
            

                import Comp29 from './comp/openstreetmap.vue';
                Vue.component('voffice-openstreetmap',Comp29);
            

                import Comp30 from './comp/SearchFilterTokens-v2.vue';
                Vue.component('search-filter-tokens-v2',Comp30);
            

                import Comp31 from './comp/Voucher-Search.vue';
                Vue.component('voffice-voucher-search',Comp31);
            

                import Comp32 from './offershelp.vue';
                Vue.component('offer-help',Comp32);
            

                import Comp33 from './comp/ContactForm.js';
                Vue.component('voffice-form',Comp33);
            

                import Comp34 from './comp/IncreaseNumber.vue';
                Vue.component('increase-number',Comp34);
            

                import Comp35 from './comp/Voucher.vue';
                Vue.component('voffice-voucher',Comp35);
            

                import Comp36 from './comp/NewsletterSubsription.js';
                Vue.component('voffice-newsletter-subscription',Comp36);
            

        Vue.mixin({
            methods: methods
        });

        const datepickerOptions = {
            days: voMsg('weekdayslist').split(','),
            daysShort: voMsg('weekdayslist.short').split(','),
            monthNames: voMsg('monthlist.full').split(',')
        };
        Vue.use(AirbnbStyleDatepicker, datepickerOptions);


    	var passThrough = function (val) {
			return val || '';
		};

    	var filterCodes = [
    	    'vlang',
    	    'vautolang',
    	    'vsoption',
    	    'vsPropOption'
    	  ];

        for (let fc of filterCodes) {
    		Vue.filter(fc, passThrough);
    	};


        var vueAppEls = document.body.querySelectorAll('[vo-vue-app]');

        for (let el of vueAppEls) {
            let vName = el.getAttribute("vo-vue-app");
            let v = vueApps[vName];
            if (v) {
                v.el = el;
                V.log("creating vue app",vName);

                let app = new Vue(v);
            }

        }

        VOFFICE.afterAllLoaded = function(){
            document.documentElement.classList.add("app-loaded");
        };

        window.addEventListener('beforeunload', function (event) {
        	document.documentElement.classList.add("app-leaving");
        });


    